import { RegisteredComponent } from "@builder.io/sdk-react";

export const apiWrapperBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "API Wrapper",
  inputs: [
    {
      name: "onInitialize",
      type: "javascript",
      helperText: "Add api call you want to execute on component load",
      localized: false,
    },
  ],
  canHaveChildren: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderLinkComponent: true,
    builderContext: true,
  },
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Text",
        options: {
          text: "Lorem ipsum",
        },
      },
    },
  ],
};
